// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Hook for fetching and managing location data.
 * Provides a convenient interface for accessing location information.
 */
import { getLocation } from '@/location/api/get-location';
import { useSuspenseQuery } from '@tanstack/react-query';

/**
 * Hook that fetches and returns location data for a specific location key.
 * Uses React Query for data fetching and caching.
 *
 * @param locationKey - The unique key identifier for the location
 * @returns Object containing the location data
 */
export function useLocation(locationKey: string) {
  const { data } = useSuspenseQuery({
    queryKey: ['location', locationKey],
    queryFn: () => getLocation(locationKey),
  });

  return { location: data.location };
}
